import React from 'react';
import '../../styles/pages.css';

const PrivacyPolicy = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Privacy Policy</h1>
        <p className="page-update">Last Updated: April 5, 2025</p>
      </div>
      
      <div className="page-content policy-content">
        <section className="policy-section">
          <h2>1. Introduction</h2>
          <p>At RoweBros Party Rentals ("we," "our," or "us"), we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>
          <p>Please read this Privacy Policy carefully. By accessing or using our services, you acknowledge that you have read, understood, and agree to be bound by all the terms of this Privacy Policy. If you do not agree, please do not access or use our services.</p>
        </section>
        
        <section className="policy-section">
          <h2>2. Information We Collect</h2>
          
          <h3>2.1 Personal Information</h3>
          <p>We may collect personal information that you voluntarily provide to us when you:</p>
          <ul>
            <li>Register for an account</li>
            <li>Place a rental order</li>
            <li>Sign up for our newsletter</li>
            <li>Contact us with inquiries</li>
            <li>Participate in promotions or surveys</li>
          </ul>
          <p>This information may include:</p>
          <ul>
            <li>Name, email address, phone number</li>
            <li>Billing and delivery address</li>
            <li>Payment information</li>
            <li>Event details (date, time, location)</li>
            <li>Account credentials</li>
          </ul>
          
          <h3>2.2 Automatically Collected Information</h3>
          <p>When you visit our website, we may automatically collect certain information about your device and usage patterns, including:</p>
          <ul>
            <li>IP address and browser type</li>
            <li>Operating system</li>
            <li>Referring URLs</li>
            <li>Pages viewed and time spent</li>
            <li>Device information</li>
            <li>Location information</li>
          </ul>
        </section>
        
        <section className="policy-section">
          <h2>3. How We Use Your Information</h2>
          <p>We may use your information for various purposes, including:</p>
          <ul>
            <li>Providing and maintaining our services</li>
            <li>Processing and fulfilling rental orders</li>
            <li>Verifying your identity and processing payments</li>
            <li>Sending administrative information and rental confirmations</li>
            <li>Responding to your inquiries and providing customer support</li>
            <li>Sending marketing and promotional communications (with option to opt out)</li>
            <li>Improving our website, products, and services</li>
            <li>Protecting against fraudulent or unauthorized transactions</li>
            <li>Complying with legal obligations</li>
          </ul>
        </section>
        
        <section className="policy-section">
          <h2>4. Sharing Your Information</h2>
          <p>We may share your information with:</p>
          <ul>
            <li><strong>Service Providers:</strong> Third-party vendors who perform services on our behalf, such as payment processing, delivery services, and email marketing.</li>
            <li><strong>Business Partners:</strong> When necessary to provide you with services, such as event venues or caterers you may have requested.</li>
            <li><strong>Legal Requirements:</strong> When required by law, court order, or governmental authority.</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
          </ul>
          <p>We do not sell your personal information to third parties for their marketing purposes.</p>
        </section>
        
        <section className="policy-section">
          <h2>5. Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, loss, misuse, or alteration. However, no method of transmission over the Internet or electronic storage is 100% secure, so we cannot guarantee absolute security.</p>
        </section>
        
        <section className="policy-section">
          <h2>6. Your Rights and Choices</h2>
          <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
          <ul>
            <li>Accessing, correcting, or updating your personal information</li>
            <li>Deleting your personal information</li>
            <li>Restricting or objecting to our use of your personal information</li>
            <li>Receiving a copy of your personal information in a structured format</li>
            <li>Withdrawing consent at any time (where processing is based on consent)</li>
          </ul>
          <p>To exercise these rights, please contact us using the information provided in the "Contact Us" section.</p>
        </section>
        
        <section className="policy-section">
          <h2>7. Cookies and Tracking Technologies</h2>
          <p>We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, some features of our website may not function properly without cookies.</p>
        </section>
        
        <section className="policy-section">
          <h2>8. Children's Privacy</h2>
          <p>Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.</p>
        </section>
        
        <section className="policy-section">
          <h2>9. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time. The updated version will be indicated by an updated "Last Updated" date. We encourage you to review this Privacy Policy frequently to stay informed about how we are protecting your information.</p>
        </section>
        
        <section className="policy-section">
          <h2>10. Contact Us</h2>
          <p>If you have questions or concerns about this Privacy Policy or our privacy practices, please contact us at:</p>
          <p>
            RoweBros Party Rentals<br />
            123 Main St, Angola, IN 46703<br />
            Email: privacy@rowebros.com<br />
            Phone: (260) 226-5640
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
